module.exports = "/images/Single House.svg?9184a8a545e1e8ad1a9c9627705f49c4";